// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Discover = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M15.1950597,26.3968721 C13.2547551,24.9371157 12,22.6150897 12,20 C12,17.3849103 13.2547551,15.0628843 15.1950597,13.6031279 C11.2432672,14.615905 7.74792325,16.8601188 5.25607854,20 C7.74792325,23.1398812 11.2432672,25.384095 15.1950597,26.3968721 Z M24.8049403,13.6031279 C26.7452449,15.0628843 28,17.3849103 28,20 C28,22.6150897 26.7452449,24.9371157 24.8049403,26.3968721 C28.7567328,25.384095 32.2520767,23.1398812 34.7439215,20 C32.2520767,16.8601188 28.7567328,14.615905 24.8049403,13.6031279 Z M20,12 C26.6245193,12 32.477277,15.1640424 36,20 C32.477277,24.8359576 26.6245193,28 20,28 C13.3754807,28 7.52272299,24.8359576 4,20 C7.52272299,15.1640424 13.3754807,12 20,12 Z M20,27 C23.8659932,27 27,23.8659932 27,20 C27,16.1340068 23.8659932,13 20,13 C16.1340068,13 13,16.1340068 13,20 C13,23.8659932 16.1340068,27 20,27 Z M20,24 C17.790861,24 16,22.209139 16,20 C16,17.790861 17.790861,16 20,16 C22.209139,16 24,17.790861 24,20 C24,22.209139 22.209139,24 20,24 Z M20,23 C21.6568542,23 23,21.6568542 23,20 C23,18.3431458 21.6568542,17 20,17 C18.3431458,17 17,18.3431458 17,20 C17,21.6568542 18.3431458,23 20,23 Z" />
        </G>
    );
};

export default Discover;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/discover/index.js